import axios from 'axios'
import Cookies from 'js-cookie'

// 独立的绘图服务客户端，使用运行时注入的 DRAW_OPEN_API
const runtimeDrawApi = (typeof window !== 'undefined' && window.__APP_ENV__ && window.__APP_ENV__.DRAW_OPEN_API) ? window.__APP_ENV__.DRAW_OPEN_API : null
const envDrawApi = typeof DRAW_OPEN_API !== 'undefined' ? DRAW_OPEN_API : null

const drawRequest = axios.create({
  baseURL: runtimeDrawApi || envDrawApi || 'http://192.168.19.20:5002'
})

drawRequest.interceptors.request.use(config => {
  if (Cookies.get('draw_token')) {
    config.headers['Authorization'] = Cookies.get('draw_token')
  }
  return config
}, error => Promise.reject(error))

export default drawRequest


// WEBPACK FOOTER //
// ./src/request/draw.js